var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoanCombineA = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 17,
  height: 20.003,
  viewBox: "0 0 17 20.003",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.824,
  y1: 0.89,
  x2: 0.29,
  y2: 0.277,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#288e11"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ded602"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  "data-name": "Union 2",
  d: "M4218,12999.5a4.5,4.5,0,1,1,4.5,4.5A4.5,4.5,0,0,1,4218,12999.5Zm1,0a3.5,3.5,0,1,0,3.5-3.5A3.5,3.5,0,0,0,4219,12999.5Zm-1.054,2.5H4211a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v9.526a5.368,5.368,0,0,0-1-.2V12985h-12v16h6.527a5.043,5.043,0,0,0,.421,1v0Zm2.9-1.851.721-.669.509.545c.016-.779,0-2.559,0-2.578v-.1h.992v.1c0,.02.026,1.69.006,2.618l.552-.516.672.718-1.785,1.667Zm-7.34-3.148a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Zm0-3a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Zm.017-2.758v-.509a1.151,1.151,0,0,1-1.061-1.243v-.046h.734l-.006.052a.688.688,0,0,0,.153.474.563.563,0,0,0,.424.16h.006a.579.579,0,0,0,.415-.134.423.423,0,0,0,.134-.262l0-.081a.463.463,0,0,0-.127-.33,1.247,1.247,0,0,0-.447-.244,3.493,3.493,0,0,1-.512-.213,1.088,1.088,0,0,1-.633-1.008,1.034,1.034,0,0,1,.277-.744,1.142,1.142,0,0,1,.7-.343v-.567h.516v.574a1.08,1.08,0,0,1,.686.392,1.362,1.362,0,0,1,.258.861v.046h-.731l0-.053a.774.774,0,0,0-.137-.482.44.44,0,0,0-.343-.17h-.039a.5.5,0,0,0-.333.127.494.494,0,0,0-.124.35v0a.472.472,0,0,0,.124.326,1.272,1.272,0,0,0,.45.245,4.38,4.38,0,0,1,.532.231,1.44,1.44,0,0,1,.33.245.989.989,0,0,1,.212.319,1.146,1.146,0,0,1,.075.428,1.035,1.035,0,0,1-.281.744,1.238,1.238,0,0,1-.737.336v.516Zm3.981-.244a.5.5,0,1,1,0-1h3a.5.5,0,0,1,0,1Zm0-3a.5.5,0,1,1,0-1h3a.5.5,0,0,1,0,1Z",
  transform: "translate(2511 647.999)",
  fill: "url(#linear-gradient)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_loan_combine_a",
  transform: "translate(-6720.999 -13631.998)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_275",
  "data-name": "Rectangle 275",
  width: 17,
  height: 20,
  transform: "translate(6721 13632.001)",
  fill: "url(#linear-gradient)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoanCombineA);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_loan_combine_a.5e7d65ea64f5c20a5584b2b236691d03.svg";